<template>
    <div class="message-view-modal" v-if="message">
        <b-modal hide-footer
                 :id="modalId"
                 :title="message['subject']">
            <div>
                <div class="d-flex mb-3">
                    <strong>From: </strong>
                    <user-details :user="message['fromUser']"
                                  style="padding: 0 0 15px 10px"/>
                </div>

                <div class="d-flex justify-content-between mb-3">
                    <div>
                        <strong>Subject: </strong>{{ message['subject'] }}
                    </div>
                    <div class="text-right">
                        <strong>Sent: </strong>
                        <timestamp :date="message.sent"/>
                    </div>
                </div>
                <strong>Message: </strong>
                <p style="word-break: break-all">{{ message['body'] }}</p>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'MessageViewModal',
    props: {
        message: Object,
        modalId: String,
    }
}
</script>
